import {create} from 'zustand';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import type {IUserPreference} from '../schema/userPreference';

interface UserPreferenceState {
    userPreferences: IUserPreference;
    get: <Bool extends boolean = false>(pref: string, asBoolean?: Bool) => Bool extends true ? boolean : string | null | undefined;
    set: (pref: string, value?: string | number | boolean | null) => void;
};

export const useUserPreferencesStore = create<UserPreferenceState>()((set, get) => ({
    userPreferences: {},
    get: <Bool extends boolean = false>(pref: string, asBoolean?: Bool) => {
        let preference: string | boolean | null = !pref ? null : get().userPreferences[pref];
        if (asBoolean === true) preference = preference == 'true';
        return preference as Bool extends true ? boolean : string | null | undefined;
    },
    set: (pref, value) => {
        if (!pref) return;
        // hack until we move control of pref logic out of backbone
        dispatcher.trigger('user:prefs:set', pref, value);
        set(state => ({
            ...state,
            userPreferences: {
                ...state.userPreferences,
                [pref]: value?.toString() ?? null,
            }
        }));
    }
}));
